/**
 * No modo "Próximos dias", o chip do relógio no topo do mapa (celular) e o do
 * status (desktop) mostram o instante PREVISTO e a rodada — no lugar da hora
 * da imagem do satélite, para nunca haver dois relógios na tela.
 */
import clsx from 'clsx';
import { SOBRE_MODELO_TEMPO, instanteDaRodada } from './api';
import { camadaDe } from './camadas';
import { rodadaEmUso } from './motor';
import { tempoEmUso, usePrevisaoStore } from './store';
import { rotuloDoInstante } from './tempo';

export function rotuloDaRodadaCurto(r: string): string {
  const d = new Date(instanteDaRodada(r));
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getUTCHours())} UTC ${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)}`;
}

export function RelogioDaPrevisao(props: {
  compacto?: boolean;
  className?: string;
  /**
   * No pé do celular: o "PREVISÃO" some em tela estreita (< 380 px), onde o relógio cortava o texto;
   * o selo "Modelo, não medição" no topo e o violeta já dizem que é previsão.
   */
  rotuloCurto?: boolean;
}) {
  const instante = usePrevisaoStore((s) => s.instante);
  const variavel = usePrevisaoStore((s) => s.variavel);
  const fumaca = usePrevisaoStore((s) => s.fumaca);
  const cenario = usePrevisaoStore((s) => s.cenario);
  const indice = usePrevisaoStore((s) => s.indice);
  const rodadas = usePrevisaoStore((s) => s.rodadas);
  const tempo = usePrevisaoStore(tempoEmUso);
  const camada = camadaDe(variavel, fumaca, cenario, tempo);
  const rodada = rodadaEmUso(indice?.modelos[camada.modelo], rodadas[camada.modelo]);
  const fonte = camada.modelo === 'cams' ? 'CAMS' : camada.modelo === 'wn2' ? 'WeatherNext 2' : SOBRE_MODELO_TEMPO[tempo].nome;
  return (
    <div className={clsx('flex min-w-0 flex-col leading-tight', props.className)} data-relogio-previsao="" aria-live="polite">
      <span className="truncate text-sm text-white tabular-nums">
        <span className={clsx('mr-1 text-[11px] font-medium text-violet-300', props.rotuloCurto && 'max-[379px]:hidden')}>
          Previsão
        </span>
        {instante !== null ? rotuloDoInstante(instante) : '…'}
      </span>
      <span className="truncate text-[11px] text-ink-300">{rodada ? `${fonte} ${rotuloDaRodadaCurto(rodada)} · Brasília` : 'carregando…'}</span>
    </div>
  );
}
